import React from 'react';
import {List, ListItem} from 'material-ui/List';
import Home from 'material-ui/svg-icons/action/home';
import Assessment from 'material-ui/svg-icons/action/assessment';
import Strategic from 'material-ui/svg-icons/editor/pie-chart';
import Email from 'material-ui/svg-icons/communication/email';
import Efficience from 'material-ui/svg-icons/av/playlist-add-check';
import Divider from 'material-ui/Divider';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Cached from 'material-ui/svg-icons/action/cached';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router-dom';
import Subheader from 'material-ui/Subheader';

import  './Sidebar.css'

class Sidebar extends React.Component {    
  constructor(props) {
    super(props);
    this.state = {open: false};
  }
  handleToggle = () => this.setState({open: !this.state.open});

  render() {      
    return (        
        
            <Paper zDepth={1} >                                                   
                <List>
                    <Link to={`/`}> 
                        <ListItem primaryText="Home" leftIcon={<Home />} />
                    </Link>                                   
                </List>                
                <Divider />             
                <List>     
                    <Subheader>Relatórios</Subheader>           
                    <Link to={`/reports/active`}> 
                        <ListItem primaryText="Alumni ativos" leftIcon={<Assessment />} />                
                    </Link>
                    <Link to={`/reports/extent`}> 
                        <ListItem primaryText="Alcance" leftIcon={<Email />} />
                    </Link>                
                    <Link to={`/reports/efficience`}> 
                        <ListItem primaryText="Eficiência" leftIcon={<Efficience />} />
                    </Link>                
                    <Link to={`/reports/strategic`}> 
                        <ListItem primaryText="Informação estratégica" leftIcon={<Strategic />} />
                    </Link>                
                </List>
                <Divider />          
                <List>
                    <Subheader>Administrativo</Subheader>           
                    <Link to={`/update`}> 
                        <ListItem primaryText="Atualizar dados" rightIcon={<Cached />} />                
                    </Link>                
                </List>                                   
                <List>
                    <Subheader>Dados</Subheader>           
                    <Link to={`/retrieve-mentoring-data`}> 
                        <ListItem primaryText="Mentoria" rightIcon={<Cached />} />                
                    </Link>                
                </List>                                   
            </Paper>         
    );
  }
}
export default Sidebar;


// WEBPACK FOOTER //
// ./src/layout/Sidebar.js